import { CommercialOption, FormValues, IFilter, NumberOptions, StringOptions } from "../../types";
import {
  formatDate,
  formatDateFilter,
} from "../../../../../utils/generalFormat";
import { Button, Col, Container, Label } from "../../styles";
import { Row, Checkbox } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "antd/lib/select";
import VendaServices from "../../../../transacoesErepasses/painelDeVendas/services/VendaServices";
import useGetMe from '../../../../../hooks/useCurrentUser'
import { can, PortalPermissions } from "../../../../../config/permissions";


export const FormFilter: React.FC<IFilter> = (props: IFilter) => {
  const { getFilters, userType } = props;
  const [commercialHierId, setCommercialHierId] = useState<any>(null);
  const [commercialOptions, setCommercialOptions] = useState<CommercialOption[]>([]);
  const [filteredCommercialOptions, setFilteredCommercialOptions] = useState<CommercialOption[]>([]);
  const user = useGetMe();
  const vendasServices = new VendaServices();
  // Mesma permissão que decide o botão e a consulta automática ao abrir a tela:
  // esconder só o botão deixaria o useEffect abaixo consultando sem permissão.
  const podeConsultar = can(PortalPermissions.liquidacao.recebiveis.consultar);


  const getInitialValues = (): FormValues => {
    const date = new Date();
    date.setHours(0, 0, 0, 1);
    const startDate = formatDate(date);
    date.setHours(23, 59, 59, 59);
    const finishDate = formatDate(date);
    return {
      startDate: startDate,
      finishDate: finishDate,
      brand: "",
      merchantId: "",
      acquirerNsu: "",
      acquirer: -1,
      productName: "",
      isAdmin: userType === 3 ? true : false,
      commercialHierId: -1,
      parcels: -1
    };
  };

  const handleChangeInitialDate = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = event.target;
    const date = new Date(value + "T03:00:00Z");
    setFieldValue("startDate", date);
  };

  const handleChangeFinishDate = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = event.target;
    const date = new Date(value + "T02:59:59Z");
    date.setDate(date.getDate() + 1);
    setFieldValue("finishDate", date);
  };

  const getSettlementReceivables = async (submit: any) => {
    if (submit.startDate === "") {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      submit.startDate = formatDateFilter(date);
    } else {
      const formattedDateStart = formatDateFilter(submit.startDate);
      submit.startDate = formattedDateStart;
    }

    if (submit.finishDate === "") {
      const tomorrow = new Date();
      tomorrow.setHours(23, 59, 59, 0);
      submit.finishDate = formatDateFilter(tomorrow);
    } else {
      const formattedDateFinish = formatDateFilter(submit.finishDate);
      submit.finishDate = formattedDateFinish;
    }

    console.log(submit);
    getFilters(submit);
    return submit;
  };

  const brandOptions: StringOptions[] = [
    { label: "Bandeira", value: "" },
    { label: "Visa", value: "Visa" },
    { label: "Master", value: "Master" },
    { label: "Amex", value: "Amex" },
    { label: "Hiper", value: "Hiper" },
    { label: "Elo", value: "Elo" },
    { label: "Pix", value: "Pix" },
  ];

  const acquirerOptions: NumberOptions[] = [
    { label: "Adquirente", value: -1 },
    { label: "Adiq", value: 3 },
    { label: "Rede", value: 10 },
    { label: "Valori", value: 99 },
  ];

  const paymentOptions: StringOptions[] = [
    { label: "Tipo Pagamento", value: "" },
    { label: "Débito", value: "Débito" },
    { label: "Crédito à Vista", value: "Crédito à Vista" },
    { label: "Parcelamento sem Juros", value: "Parcelamento sem Juros" },
    { label: "Pix", value: "Pix" },
  ];

  const parcelsOptions: NumberOptions[] =[
    { label: "Qtd. Parcelas", value: -1 },
    { label: "À Vista", value: 1 },
    { label: "2 x 6 Parcelas", value: 2 },
    { label: "7 x 12 Parcelas", value: 3 },
    { label: "13 x 21 Parcelas", value: 4 },
  ];

  const handleCommercialHierId = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void) => {
      const value = event.target.value;

      // filtrar a lista de oções

      if (value.trim() === '') {
        setFilteredCommercialOptions([]);
      } else {
        setFilteredCommercialOptions(
          commercialOptions.filter(option =>
            option.commercialLevelName.toLowerCase().includes(value.toLowerCase())
          )
        );
      }

      setCommercialHierId(event.target.value);
      setFieldValue('commercialHierId', event.target.value);
    };

    const handleSelect = (
      option: CommercialOption,
      setFieldValue: (field: string, value: any) => void
    ) => {
      setCommercialHierId(option.commercialLevelName);
      setFieldValue('commercialHierId', option.id);
      setFilteredCommercialOptions([]);
    };

    const handleCommercialOptions = async (): Promise<CommercialOption[]> => {
      return await vendasServices.getCommercialOptions();
    };

  useEffect(() => {
    if (!podeConsultar) return;
    getSettlementReceivables(getInitialValues());
  }, [podeConsultar]);

  useEffect(() => {
      handleCommercialOptions()
        .then(response => setCommercialOptions(response));
    }, []);

  return (
    <Container style={{ padding: "0px" }}>
      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik
        initialValues={getInitialValues()}
        onSubmit={async (values: any) => {
          await getSettlementReceivables(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Row gutter={16}>
              {(userType === 3) && (
                <Col>
                  <Field name="isAdmin">
                    {({ field, form }: any) => (
                      <Checkbox
                        {...field}
                        checked={field.value}
                        onChange={(event) => {
                          form.setFieldValue("isAdmin", event.target.checked);
                          form.submitForm(); // Forçar submissão
                        }}
                      >
                        Valori
                      </Checkbox>
                    )}
                  </Field>
                </Col>
              )}


              {(userType === 3) && (
                <Col>
                  <Field name="isAdmin">
                    {({ field, form }: any) => (
                      <Checkbox
                        {...field}
                        checked={!field.value}
                        onChange={(event) => {
                          form.setFieldValue("isAdmin", !event.target.checked);
                          form.submitForm(); // Forçar submissão
                        }}
                      >
                        Parceiro
                      </Checkbox>
                    )}
                  </Field>
                </Col>
                )}

            </Row>
            <Row gutter={16}>
              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeInitialDate(e, setFieldValue)}
                  name="startDate"
                  placeholder="Data Inicial"
                  step="1"
                />
              </Col>

              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeFinishDate(e, setFieldValue)}
                  name="finisDate"
                  placeholder="Data Final"
                  step="1"
                />
              </Col>

              <Col>
                <Field
                  type="text"
                  name="merchantId"
                  placeholder="Cód. Lojista"
                />
              </Col>

              <Col>
                <Select
                  value={values.brand}
                  style={{ width: "100%" }}
                  onChange={(value) => setFieldValue("brand", value)}
                  options={brandOptions}
                />
              </Col>

              <Col>
                <Field type="text" name="acquirerNsu" placeholder="NSU" />
              </Col>

              {(userType === 3) &&  (
                <Col>
                  <Select
                    value={values.acquirer}
                    style={{ width: "100%" }}
                    onChange={(value) => setFieldValue("acquirer", value)}
                    options={acquirerOptions}
                  />
                </Col>
                )}

              <Col>
                <Select
                  value={values.productName}
                  style={{ width: "100%" }}
                  onChange={(value) => setFieldValue("productName", value)}
                  options={paymentOptions}
                />
              </Col>

              <Col>
                <Select
                  value={values.parcels}
                  style={{ width: "100%" }}
                  onChange={(value) => setFieldValue("parcels", value)}
                  options={parcelsOptions}
                />
              </Col>

              {(user.userType === 3 || user.userType === 6 || user.userType === 7) && (
                          <Col xs={{ flex: '100%' }}
                               sm={{ flex: '50%' }}
                               md={{ flex: '40%' }}
                               lg={{ flex: '20%' }}
                               xl={{ flex: '10%' }}>
                            <input
                            type="text"
                            value={commercialHierId}
                            onChange={(e) => handleCommercialHierId(e, setFieldValue)}
                            placeholder="Filtro comercial"/>
                            {filteredCommercialOptions.length > 0 && (
                              <ul
                                style={{
                                  listStyle: 'none',
                                  margin: 0,
                                  padding: 0,
                                  position: 'absolute',
                                  width: '100%',
                                  backgroundColor: '#fff',
                                  border: '1px solid #ccc',
                                  zIndex: 10
                                }}
                              >
                                {filteredCommercialOptions.map(option => (
                                  <li
                                    key={option.id}
                                    onClick={() => handleSelect(option, setFieldValue)}
                                    style={{
                                      padding: '8px',
                                      cursor: 'pointer',
                                      borderBottom: '1px solid #eee'
                                    }}
                                  >
                                    {option.commercialLevelName}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </Col>
                        )}

              {podeConsultar && (
                <Col>
                  <Button htmlType="submit">Consultar</Button>
                </Col>
              )}
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
